// extracted by mini-css-extract-plugin
export default {"loader":"_3UVAKF0zlLKTKPasb88UmG"};